"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePickerDayOfWeekHeader = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var DatePickerWidgetStyles_1 = require("../../styles/DatePickerWidgetStyles");
var Date_1 = require("../../utils/Date");
var DatePickerDayOfWeekHeader = /** @class */ (function (_super) {
    tslib_1.__extends(DatePickerDayOfWeekHeader, _super);
    function DatePickerDayOfWeekHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DatePickerDayOfWeekHeader.prototype.getDayOfWeekHeader = function () {
        var startDayOfWeek = Date_1.getStartDayOfWeek(!!this.props.showWeekNumbers);
        var dayOfWeek = Date_1.getLocalizedDaysOfWeek(startDayOfWeek);
        if (this.props.showWeekNumbers) {
            dayOfWeek.unshift('#');
        }
        return dayOfWeek;
    };
    DatePickerDayOfWeekHeader.prototype.render = function () {
        var _this = this;
        var weekOfDayHeader = [];
        this.getDayOfWeekHeader().forEach(function (header, index) {
            var style = _this.props.showWeekNumbers && index === 0 ?
                DatePickerWidgetStyles_1.datePickerCellStyles.isoWeekNumColHeader :
                DatePickerWidgetStyles_1.datePickerCellStyles.dayOfWeekColHeader;
            weekOfDayHeader.push(React.createElement("div", { key: index, style: style, role: 'columnheader' }, header));
        });
        return (React.createElement("div", { style: DatePickerWidgetStyles_1.datePickerDayOfWeekHeaderStyle, role: 'rowheader' }, weekOfDayHeader));
    };
    return DatePickerDayOfWeekHeader;
}(React.Component));
exports.DatePickerDayOfWeekHeader = DatePickerDayOfWeekHeader;
//# sourceMappingURL=DatePickerDayOfWeekHeader.js.map